import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import { AppBar, Toolbar } from '@material-ui/core';
import { productsPrefix, productsDetails } from 'routes/routes';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Menu from '@material-ui/icons/Menu';
import { Row } from 'components/UI/Row';
import { Column } from 'components/UI/Column';
import { setAppMenuOpen } from 'components/AppMenu/appMenu';
import { getProduct, getProductFormLoaders, getProductFormApiErrors } from 'features/ProductDetails/productForm';
import { ProductDetailsTabs } from './ProductDetailsTabs';

const ProductsNavBar = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const productsMatch = useRouteMatch(`${productsPrefix}`)?.isExact;
  const productsFormMatch = useRouteMatch(`${productsPrefix}/new`)?.isExact;
  const productsDetailsMatch = useRouteMatch(`${productsPrefix}${productsDetails}/*`);

  const product = useSelector(getProduct);
  const { isLoading } = useSelector(getProductFormLoaders);
  const { loadingError } = useSelector(getProductFormApiErrors);

  return (
    <AppBar position="sticky">
      <Toolbar className="navColor" style={{ paddingLeft: 0, paddingRight: 0 }}>
        {productsMatch && (
          <Row justifyContent="space-between" alignItems="center" height="64px">
            <IconButton aria-label="menu" color="inherit" onClick={() => dispatch(setAppMenuOpen(true))}>
              <Menu />
            </IconButton>
            <IconButton aria-label="delete" color="inherit" onClick={() => history.push('/profile')}>
              <AccountCircle />
            </IconButton>
          </Row>
        )}
        {(productsFormMatch || productsDetailsMatch) && (
          <Column>
            <Row justifyContent="space-between" alignItems="center" height="64px">
              <IconButton aria-label="back" color="inherit" onClick={() => history.push('/products')}>
                <ArrowBackIosIcon />
              </IconButton>
              {isEmpty(loadingError) && <span>{!isLoading && (product?.name || t('products.new product'))}</span>}
              <IconButton aria-label="profile" color="inherit" onClick={() => history.push('/profile')}>
                <AccountCircle />
              </IconButton>
            </Row>
            <Row>
              <ProductDetailsTabs />
            </Row>
          </Column>
        )}
      </Toolbar>
    </AppBar>
  );
};

export { ProductsNavBar };
